import { request } from '../boot/request';

const getProductDetails = (id, params) => {
  params = params || {};
  return request({
    url: `/products/${id}`,
    method: 'GET',
    params,
  });
};

export { getProductDetails };
